import React, { useEffect } from "react";
import "./AboutUs.css";
import Navbar from "./Navbar.js";
import aboutus from "../../src/assets/aboutus.png";
import neelesh from "../../src/assets/neeleshshah.jpg";
import krishna from "../../src/assets/krishna.jpg";
import shailesh from "../../src/assets/shailesh.jpg";
import Footer from "./Footer.js";

export default function AboutUs() {
  useEffect(() => {
    // jump to top when this route mounts
    window.scrollTo({ top: 0, behavior: "auto" }); // use 'smooth' if you prefer animation
  }, []);
  const teamMembers = [
    {
      id: 1,
      name: "Neelesh Shah",
      role: "Partner",
      img: neelesh,
      socials: { linkedin: "#", twitter: "#", instagram: "#" },
    },
    {
      id: 2,
      name: "Krishna Bawkar",
      role: "Partner",
      img: krishna,
      socials: { linkedin: "#", twitter: "#", instagram: "#" },
    },
    {
      id: 3,
      name: "Shailesh Dube",
      role: "Partner",
      img: shailesh,
      socials: { linkedin: "#", twitter: "#", instagram: "#" },
    },
  ];
  return (
    <div className="aboutUs">
      <Navbar />
      <div className="about-us-title">
        <h1>About Us</h1>
      </div>
      <img src={aboutus} className="aboutUs-img" alt="AboutUs" />
      <div className="aboutus-text">
        At CISL, we are a trusted IT solutions company with over 20 years of
        industry experience, delivering reliable, efficient, and scalable
        technology services to businesses of all sizes.
        <br />
        We specialize in Annual Maintenance Contracts (AMC), Facility Management
        Services (FMS), and call-based IT support, ensuring that your systems
        run smoothly with minimal downtime. Our commitment is to provide
        proactive maintenance and quick resolution, so you can focus on growing
        your business.
        <br />
        In addition to services, CISL also offers a wide range of IT products,
        including desktops, laptops, servers, printers, CCTV systems, and audio
        solutions such as speakers. We partner with leading brands to deliver
        quality hardware that meets modern business needs. What sets us apart is
        our dedicated team of highly skilled engineers, who bring expertise,
        professionalism, and a customer-first approach to every project. Whether
        it’s support, setup, or system management, our team ensures dependable
        performance and long-term value. At CISL, we believe in building
        long-lasting relationships with our clients through trust, quality
        service, and continuous innovation.
      </div>
      <div className="partners-grid">
        {teamMembers.map((m) => (
          <article key={m.id} className="partner-card">
            <div className="avatar-wrap">
              <img src={m.img} alt={`${m.name}`} className="avatar" />
            </div>

            <div className="partner-info">
              <h3 className="partner-name">{m.name}</h3>
              <p className="partner-role">{m.role}</p>
            </div>

            <div className="partner-socials" aria-hidden={false}>
              {m.socials?.linkedin && (
                <a
                  href={m.socials.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-btn"
                  aria-label={`${m.name} on LinkedIn`}
                >
                  <svg viewBox="0 0 24 24" className="icon">
                    <path d="M4.98 3.5C4.98 4.88 3.9 6 2.49 6C1.08 6 .01 4.88 .01 3.5C.01 2.12 1.08 1 2.49 1C3.9 1 4.98 2.12 4.98 3.5zM.2 8.98H4.8V24H.2zM8.98 8.98H13.37V10.78H13.44C13.99 9.83 15.49 8.78 17.57 8.78C21.74 8.78 22 11.5 22 15.25V24H17.4V15.98C17.4 13.99 17.36 11.49 14.62 11.49C11.86 11.49 11.41 13.67 11.41 15.82V24H6.81z" />
                  </svg>
                </a>
              )}

              {m.socials?.twitter && (
                <a
                  href={m.socials.twitter}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-btn"
                  aria-label={`${m.name} on Twitter`}
                >
                  <svg viewBox="0 0 24 24" className="icon">
                    <path d="M22.46 6c-.77.35-1.6.58-2.46.69a4.3 4.3 0 0 0 1.88-2.37 8.59 8.59 0 0 1-2.72 1.04 4.28 4.28 0 0 0-7.3 3.9A12.15 12.15 0 0 1 3.15 4.7 4.27 4.27 0 0 0 4.18 10a4.2 4.2 0 0 1-1.94-.54v.05a4.28 4.28 0 0 0 3.43 4.2 4.3 4.3 0 0 1-1.93.07 4.28 4.28 0 0 0 4 2.98A8.59 8.59 0 0 1 2 19.54 12.12 12.12 0 0 0 8.29 21c7.55 0 11.68-6.26 11.68-11.68 0-.18-.01-.35-.02-.53A8.36 8.36 0 0 0 22.46 6z" />
                  </svg>
                </a>
              )}

              {m.socials?.instagram && (
                <a
                  href={m.socials.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-btn"
                  aria-label={`${m.name} on Instagram`}
                >
                  <svg viewBox="0 0 24 24" className="icon">
                    <path d="M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5zm5 6.1a4.9 4.9 0 1 0 .001 9.801A4.9 4.9 0 0 0 12 8.1zm5.2-2.3a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 0 0 0-2.4z" />
                  </svg>
                </a>
              )}
            </div>
          </article>
        ))}
      </div>
      <Footer />
    </div>
  );
}
